// extracted by mini-css-extract-plugin
module.exports = {"bottomSheet":"cookie-consent-CookieConsentModal-bottomSheet-dbb68295","popUpWindow":"cookie-consent-CookieConsentModal-popUpWindow-aa4c7767"};